import { withRouter } from "react-router-dom";

import HorseDetailsPage from "./HorseDetailsPage";

export default withRouter(HorseDetailsPage);
